const themeConfig = {
  version: '1.0',
  theme: 'light', // light - dark
  contentWidth: 'full', // full - boxed
  sidebarCollapsed: false,
  sidebarCollapseButton: true,
  layout: 'VerticalLayout', // VerticalLayout - HorizontalLayout
  navigationFull: false,
  navigationBg: false,
  direction: 'ltr', // ltr - rtl
  language: 'pt', // tr - en - es - fr
};

export default themeConfig;
